import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import { capitalize } from "@mui/material";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import HeaderWrapper from "../../Header/HeaderWrapper";
import FooterWrapper from "../../Footer/FooterWrapper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";

// ✅ Convert HTML → plain text safely
const htmlToText = (html = "") => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
  } catch {
    return (html || "").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
  }
};

// ✅ Create excerpt with ellipsis only if longer than limit
const makeExcerpt = (html = "", limit = 75) => {
  const text = htmlToText(html);
  if (text.length <= limit) {
    return { excerpt: text, isLong: false };
  }
  const cut = text.slice(0, limit).trimEnd();
  return { excerpt: `${cut}…`, isLong: true };
};

function BubbleAvatarReviewPage() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [reviewsData, setReviewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    getReviewsData();
  }, []);

  const getReviewsData = async () => {
    try {
      setIsLoading(true);
      const response = await SendPostRequest("reviews");
      if (Array.isArray(response?.data) && response?.data.length > 0) {
        setReviewsData(response.data);
      } else {
        setReviewsData([]);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviewsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowMore = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReview(null);
  };

  return (
    <div className="page-wrapper-inner">
      <HeaderWrapper />
      <TextMainBannerWrapper Heading="Reviews" Image="theme-2-banner-review.webp"/>

      <div className="container">
        <h2 className="my-5 text-center">
          {isLoading
            ? ""
            : reviewsData?.length === 0
            ? "No Record Available"
            : "WHAT PATIENTS ARE SAYING"}
        </h2>

        <div className="row testimonails" data-animation="fadeInRight">
          {isLoading ? (
            <div className="d-flex align-items-center justify-content-center w-100">
              <Spinner />
            </div>
          ) : reviewsData?.length === 0 ? (
            <div className="d-flex align-items-center justify-content-center w-100"></div>
          ) : (
            reviewsData.map((data, index) => {
              const { excerpt, isLong } = makeExcerpt(data?.detail, 75);

              return (
                <div key={index} className="col-lg-4 mb-5 mt-3 item">
                  <div className="TestimonialStyle3">
                    <div className="testimonial-inner">
                      <div className="testimonial-details text-center">
                        <div className="client-details">
                          <div className="client-image">
                            <img
                              className="img-circle b-radius-50"
                              src={data?.profile_image}
                              style={{ width: "80px", height: "80px" }}
                              alt={data?.full_name}
                            />
                          </div>
                        </div>

                        <div className="testimonial-description margin-top-15">
                          <p className="mb-3 pb-1">
                            {excerpt}
                            {isLong && (
                              <>
                                {" "}
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleShowMore(data);
                                  }}
                                  className="fw-bold"
                                >
                                  See More
                                </Link>
                              </>
                            )}
                          </p>
                        </div>

                        <div className="client-info ms-3">
                          <h5 className="mb-0 text-uppercase">
                            {data?.full_name}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* ✅ Modal with full HTML detail */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedReview && (
            <div
              dangerouslySetInnerHTML={{
                __html: selectedReview?.detail || "",
              }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-default" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <FooterWrapper />
    </div>
  );
}

export default BubbleAvatarReviewPage;
